module.exports = __webpack_public_path__ + "img/288w.c7a454d.jpg";